"use client";

import { Link } from "@/components/common/Link";
import { Button, buttonVariants } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Linkedin, Phone } from "lucide-react";
import { cn } from "@/lib/utils";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        <div className="h-4 w-24 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-4 w-32 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-4 w-28 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-foreground/70 hover:text-primary text-sm transition-colors font-sans">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const contactInfo = [{
    label: "Region",
    value: "Hamburg & Schleswig Holstein\xA0"
  }, {
    label: "Telefon",
    value: "01639054671"
  }, {
    label: "E-Mail",
    value: "f.sora@pm.me"
  }, {
    label: "Büro",
    value: "Mo - So, 08:00 - 18:00"
  }];
  const socialLinks = [{
    icon: Facebook,
    url: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Instagram,
    url: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Linkedin,
    url: "https://linkedin.com",
    label: "LinkedIn"
  }];
  return <section id="footer" className="dark py-16 border-t border-border/10 !bg-[#1F2E36] lg:py-24">
      <div className="container mx-auto px-4">
        <Card className="text-card-foreground flex flex-col gap-6 backdrop-blur-xl border border-border/50 shadow-2xl rounded-2xl p-8 overflow-hidden relative !bg-[#1F2E36] lg:p-16">
          {}
          <div className="absolute -top-24 -right-24 size-64 bg-[#0B2F2A] rounded-lg blur-3xl pointer-events-none" />
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-16 relative z-10 items-center justify-between">
            {}
            <div className="lg:col-span-4 flex flex-col gap-6">
              <Link to="/">
                <img src="/img/chatgpt_image_5_mai_2026_11_43_26.png" alt="Baumpflege Straesser" className="h-8 w-auto object-contain" />
              </Link>
              <p className="text-[#CFE3DF] text-base leading-relaxed font-sans max-w-sm">Ihr zertifizierter Fachbetrieb für präzise Baumpflege, sichere Fällungen und nachhaltigen Baumschutz in der Metropolregion Hamburg und Schleswig Holstein. .</p>
              
            </div>

            {}
            
            

            {}
            <div className="lg:col-span-3">
              <h3 className="font-serif font-semibold text-[#FFFFFF] text-lg mb-6">Kontakt</h3>
              <Table className="text-sm">
                <TableBody>
                  {contactInfo.map((item, i) => <TableRow key={i} data-index={i} className="border-border/10 hover:bg-transparent">
                      <TableCell className="text-foreground/50 px-0 py-3 font-sans font-medium">{item.label}</TableCell>
                      <TableCell className="text-foreground/90 px-0 py-3 text-right font-sans">{item.value}</TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
            </div>

            {}
            
          </div>

          <Separator className="mt-16 mb-8 bg-border/10" />

          {}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-xs text-[#8FAFA8] font-mono tracking-wider uppercase">
              © 2024 Baumpflege Straesser — Hamburg & Ahrensburg
            </div>

            <div className="flex items-center gap-6 text-xs text-[#8FAFA8] font-sans">
              <Link to="/LegalNoticePage" className="hover:text-primary transition-colors">
                Impressum
              </Link>
              <Link to="/PrivacyPage" className="hover:text-primary transition-colors">
                Datenschutz
              </Link>
              
            </div>
          </div>
        </Card>
      </div>
    </section>;
}